/*/
 * Textarea auto-resize
/*/
	const siteTextarea = document.querySelector('textarea')

	if (siteTextarea) {
		siteTextarea.style.overflow = 'hidden'
		siteTextarea.style.height = _ => siteTextarea.scrollHeight

		siteTextarea.addEventListener('input', e => {
			siteTextarea.style.height = 'calc((var(--fs-small) * 2) + (1rem * var(--lh-content)))'
			siteTextarea.style.height = `${e.target.scrollHeight}px`
		}, false)

		window.addEventListener('resize', _ => {
			setTimeout(() => {
				siteTextarea.style.height = 'auto'
				siteTextarea.style.height = `${siteTextarea.scrollHeight}px`
			}, 100);
		})
	}
